/**
 * @file 
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ChangePaymentType
 * @classdesc お支払い方法変更時の処理
 */
export default class ChangePaymentType {
	/**
	 * @constructor
	 * @param {jQuery} $e - input[name=select_payment_type]
	 */
	constructor($e) {
		console.log('ChangePaymentType.constructor');
		this._$e = $e;
		$e.on('change', () => this.onChange());
		this.onChange();
	};


	/**
	 * change
	 *
	 * @memberof ChangePaymentType
	 * @return {undefined}
	 */
	onChange() {
		console.log('ChangePaymentMethod.onChange');
		const $notSpecify = $('input[id^=not_specify]');
		const $specify = $('input[id^=specify].specify');
		const $target = $('.form-card[id^=hope_delivery_date]');
		const $loppiTextWrap = $('#loppi-text-wrap');
		// コンビニ払いの場合の処理
		if ( this._$e.attr('id') === 'loppi' ) {
			// お届け日時が指定不可の場合
			if (this._$e.prop('checked') && this._$e.data('can-select-delivery-date') === 0) {
				$loppiTextWrap.show();
				// お届け日時指定のラジオボタンが存在する場合
				if ($specify.length) {
					$target.find('select').each((idx, e) => {
						const $e = $(e);
						$e.val('');
					});
					Common.hideFormWrap($target);
					$specify.prop('disabled', true);
					$notSpecify.prop('checked', true);
				// 希望日が必須指定の場合
				} else {
					$target.find('select').each((idx, e) => {
						const $e = $(e);
						$e.prop('disabled',true);
						if ($e.data('validate') === 'empty') {
							$e.addClass('ignore-validate');
						} else {
							$e.val('');
						}
					});
				}
			}
		} else {
			$loppiTextWrap.hide();
			// お届け日時指定のラジオボタンが存在する場合
			if ($specify.length) {
				$specify.prop('disabled', false);
			// 希望日が必須指定の場合
			} else {
				$target.find('select').each((idx, e) => {
					const $e = $(e);
					$e.prop('disabled',false);
					if ($e.data('validate') === 'empty') {
						$e.removeClass('ignore-validate');
					}
				});
			}
			

		}
	};
}
